/* bf26-core.js (R33 performance build). ONE deferred script for the always-on BF26 behaviour. Replaces, with no change in behaviour:
   bf26z-sitewide.js (video loop, trust slots, link fix), bf26g-ladder-ui.js, bf26-bundle-gate.js, the inline aria-label observer in
   bf26a-a11y, the inline PDP trust observer in bf26z-sitewide.liquid and the bf33-keyimage-swap observer.
   - ONE shared MutationObserver (BF26.watch) instead of six whole-document observers; callbacks run once per animation frame.
   - Videos: poster first, preload none (metadata for the first one in view), play only when the video is really on screen
     (IntersectionObserver plus a short settle check so layout shift during load cannot start below-the-fold clips).
   - Customer-review video controls load on demand from bf26-video-review.js (asset URL in window.BF26_URLS.review).
   Per-template code stays in its own files: bf26p-socks.js, bf26b2-*.js, bf26u-ux-*.js, bf26-set-composer.js, bf26-gift-gallery.js, bf26q-card.js, bf26z-pdp-gallery.js.
   r12 (13 Oct 2026): the shared ladder UI lights nodes, fill and count by info.count (real cart item_count) when the engine supplies it. Backup: assets/bf26-core-bak-20261013-r12.js
   r53 (15 Oct 2026): info.count = paid pieces (engine gifts_count). The ladder line wording lives only in message() (one writer). New section 4b updates the
   server-rendered rewards module of the cart drawer and cart page. Rollback: git revert of the r53 drawer commit.
   Rollback: put the old script tags back (bf26z-sitewide.js, bf26g-ladder-ui.js, bf26-bundle-gate.js are untouched in assets). */
(function () {
  if (window.BF26) return;
  var BF = window.BF26 = { v: 33 };
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var noop = function () {};

  /* ---------- shared observer ---------- */
  var jobs = [], raf = 0, mo = null;
  function flush() {
    raf = 0;
    for (var i = 0; i < jobs.length; i++) { try { jobs[i](); } catch (e) {} }
    if (mo) mo.takeRecords();   /* our own DOM writes do not re-trigger the jobs */
  }
  function kick() { if (!raf) raf = requestAnimationFrame(flush); }
  BF.watch = function (fn) { jobs.push(fn); };
  /* 21 Oct 2026 (speed): Klaviyo's floating teaser gets a fixed class (.rk-klt) and <body> gets .rk-has-klt, so the CSS that moves or hides it
     targets one class. The old [class*="kl-teaser"] selectors inside body:has() made every class change on the page re-check the whole page
     (about 100,000 style invalidations while the gloves page loaded). */
  function klt() {
    var t = document.querySelectorAll('div[class*="kl-teaser-"]:not(.rk-klt)');
    for (var i = 0; i < t.length; i++) t[i].classList.add('rk-klt');
    if (t.length && document.body && !document.body.classList.contains('rk-has-klt')) document.body.classList.add('rk-has-klt');
    /* 1 Nov 2026 (live hotfix): Klaviyo's popup root (the <body> child holding [aria-label="POPUP Form"]) gets .rk-klp so the CSS in
       assets/rk-system.css section 19 can hide it while the cart drawer is open. */
    var p = document.querySelectorAll('[aria-label="POPUP Form"]');
    for (var j = 0; j < p.length; j++) {
      var r = p[j];
      while (r.parentElement && r.parentElement !== document.body) r = r.parentElement;
      if (r.parentElement === document.body && !r.classList.contains('rk-klp')) r.classList.add('rk-klp');
    }
  }
  jobs.push(klt);
  BF.kick = kick;
  BF.engine = function (cb) {
    var n = 0;
    (function t() {
      var E = window.bf26gLadder;
      if (E && E.onUpdate) return cb(E);
      if (++n < 60) setTimeout(t, 250);
    })();
  };
  try { mo = new MutationObserver(kick); mo.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  /* 21 Oct 2026 (speed): ONE debounced sweep for the display-fix scripts (bf26y-r10, r10b, r11, r12, r14). They each had a page-wide observer
     and a timer, so every write by one woke all the others (forced layouts, flicker). Now: one observer, one 150 ms timer after changes stop,
     all sweeps run together and their own writes do not wake them again. */
  var lazy = [], lt = 0, lmo = null;
  function lflush() {
    lt = 0;
    for (var i = 0; i < lazy.length; i++) { try { lazy[i](); } catch (e) {} }
    if (lmo) lmo.takeRecords(); if (mo) mo.takeRecords();
  }
  function lkick() { clearTimeout(lt); lt = setTimeout(lflush, 150); }
  BF.lazy = function (fn) { lazy.push(fn); };
  try { lmo = new MutationObserver(lkick); lmo.observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'disabled'] }); } catch (e) {}
  window.addEventListener('resize', lkick);

  /* ---------- 1. videos ---------- */
  var vio = null;
  function near(v) {
    var r = v.getBoundingClientRect(), h = window.innerHeight || 800;
    return (r.width > 0 || r.height > 0) && r.bottom > -h && r.top < h + h;
  }
  try {
    vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        v.__bfvis = en.isIntersecting;
        clearTimeout(v.__bft);
        if (en.isIntersecting) {
          /* a short settle check: images above a clip can still be loading and shifting it, so only start it if it is still near the screen */
          v.__bft = setTimeout(function () { if (v.__bfvis && near(v)) start(v); }, v.__bfFirst ? 0 : 150);
        } else { try { v.pause(); } catch (e) {} }
      });
    }, { rootMargin: '100% 0px', threshold: 0.01 });
  } catch (e) {}

  function promote(v) {
    var changed = false;
    v.querySelectorAll('source').forEach(function (s) {
      if (!s.getAttribute('src') && s.getAttribute('data-src')) { s.setAttribute('src', s.getAttribute('data-src')); changed = true; }
    });
    if (!v.getAttribute('src') && v.getAttribute('data-src')) { v.setAttribute('src', v.getAttribute('data-src')); changed = true; }
    if (changed) { try { v.load(); } catch (e) {} }
  }
  function start(v) {
    promote(v);
    if (reduce || v.__bfUserPaused) return; /* r55: a clip the shopper paused (rk-video-controls.js) stays paused */
    if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(noop); }
  }
  /* Several theme sections print <source src> (not data-src) even for autoplay clips, so the browser starts fetching them at parse time.
     For any clip that is not in the first screen, move the URL to data-src and reset the element: this aborts that early fetch. promote() puts it back when the clip is near the screen. */
  function demote(v) {
    var changed = false;
    v.querySelectorAll('source[src]').forEach(function (s) {
      if (!s.getAttribute('data-src')) s.setAttribute('data-src', s.getAttribute('src'));
      s.removeAttribute('src'); changed = true;
    });
    if (v.getAttribute('src')) {
      if (!v.getAttribute('data-src')) v.setAttribute('data-src', v.getAttribute('src'));
      v.removeAttribute('src'); changed = true;
    }
    if (changed) { try { v.load(); } catch (e) {} }
  }
  function prep(v) {
    if (v.__bfp) return;
    v.__bfp = 1;
    if (v.hasAttribute('data-bf-allow-controls')) return;
    /* 25 Oct 2026 (speed): no getBoundingClientRect here (it forced a layout per video during load). Theme markup prints data-src now,
       so a clip only fetches when the IntersectionObserver below sees it near the screen; demote() still catches any src printed elsewhere. */
    var first = false;
    v.__bfFirst = first;
    if (!v.__bfvis && v.querySelector('source[src]') || (!v.__bfvis && v.getAttribute('src'))) demote(v);
    try {
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; v.controls = false;
      ['muted', 'loop', 'playsinline', 'disablepictureinpicture'].forEach(function (a) { if (!v.hasAttribute(a)) v.setAttribute(a, ''); });
      /* no autoplay attribute: the browser would fetch the clip at once. play() is called when the clip is really on screen. */
      v.removeAttribute('autoplay'); v.autoplay = false;
      v.removeAttribute('controls');
      v.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
      v.setAttribute('preload', first ? 'metadata' : 'none');
      v.setAttribute('tabindex', '-1');
      v.setAttribute('aria-hidden', 'true');
      v.style.pointerEvents = 'none';
    } catch (e) {}
    v.addEventListener('pause', function () {
      if (!v.ended && !document.hidden && v.__bfvis && !reduce && !v.__bfUserPaused) { var p = v.play(); if (p && p.catch) p.catch(noop); }
    });
    v.addEventListener('loadeddata', function () { if (v.__bfvis) start(v); });
    if (vio) vio.observe(v); else { v.__bfvis = true; start(v); }
  }
  function scanVideos() { var vs = document.querySelectorAll('video'); for (var i = 0; i < vs.length; i++) if (!vs[i].__bfp) prep(vs[i]); }

  /* a tap on a video (or its wrapper) must never pause it */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.tagName === 'VIDEO' || t.tagName === 'INTERNAL-VIDEO' || (t.classList && t.classList.contains('internal-video'))) e.stopImmediatePropagation();
  }, true);
  /* customer REVIEW videos are the one exception to the lock (small sound button, pause button, tap for sound). Their controls load on demand. */
  var REVIEW = '[id$="__studio_reviews"],[id$="__bf26g_reviews"],[id*="testimonials"],.bf27-card';
  function isRev(v) { return !!(v && v.closest && v.closest(REVIEW)); }
  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('video,internal-video,.internal-video') && !isRev(t)) e.preventDefault();
  }, true);
  document.addEventListener('volumechange', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO' || v.hasAttribute('data-bf-allow-controls')) return;
    /* r55: sound stays off unless the shopper turned it on (review videos, or __bfSound from rk-video-controls.js); one sound at a time */
    if (!isRev(v) && !v.__bfSound) { if (!v.muted) v.muted = true; return; }
    if (!v.muted) document.querySelectorAll('video').forEach(function (o) { if (o !== v && !o.muted) { o.__bfSound = false; o.muted = true; } });
  }, true);
  var revState = 0;   /* 0 not requested, 1 loading, 2 ready */
  function scanReviews() {
    var vs = document.querySelectorAll('video'), todo = [];
    for (var i = 0; i < vs.length; i++) if (!vs[i].__bfr && isRev(vs[i])) todo.push(vs[i]);
    if (!todo.length) return;
    if (revState === 2 && BF.setupReview) { todo.forEach(BF.setupReview); return; }
    if (revState === 1) return;
    var u = window.BF26_URLS && window.BF26_URLS.review;
    if (!u) return;
    revState = 1;
    var s = document.createElement('script');
    s.src = u; s.async = true;
    s.onload = function () { revState = 2; kick(); };
    s.onerror = function () { revState = 0; };
    document.head.appendChild(s);
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    document.querySelectorAll('video').forEach(function (v) { if (v.__bfvis) start(v); });
  });
  /* hand the shared helpers to the lazy review chunk */
  BF.noop = noop; BF.isRev = isRev; BF.start = start;

  /* ---------- 2. trust slots (pages that build their own markup) ---------- */
  function tpl(id) { var t = document.getElementById('bf26z-tpl-' + id); return t ? t.innerHTML : ''; }
  function slot(host, where, html, cls) {
    if (!host || !html) return;
    var d = document.createElement('div');
    d.setAttribute('data-bf26z-slot', cls);
    d.innerHTML = html;
    if (where === 'after') host.insertAdjacentElement('afterend', d);
    else host.appendChild(d);
    return d;
  }
  function slots() {
    var cta = document.querySelector('.bf26s .s-cta[data-add]:not([tabindex])');
    if (cta && !document.querySelector('[data-bf26z-slot="set"]')) slot(cta, 'after', tpl('set'), 'set');
    var gh = document.querySelector('.gs__head');
    if (gh && !gh.querySelector('[data-bf26z-slot="gs"]')) slot(gh, 'append', tpl('set'), 'gs');
    var bi = document.querySelector('.bb-bar__info');
    if (bi && !bi.querySelector('[data-bf26z-slot="bar"]')) slot(bi, 'append', tpl('sticky'), 'bar');
  }
  /* the Track Order link in the live customer-account-main-menu still points at /pages/contact; the theme points it at /pages/contact-us */
  function fixLinks() {
    var as = document.querySelectorAll('a[href$="/pages/contact"]');
    for (var i = 0; i < as.length; i++) as[i].setAttribute('href', '/pages/contact-us');
  }
  /* product pages show ONE trust line */
  var tplMeta = document.querySelector('meta[name="bf26z-template"]');
  var isProduct = !!(tplMeta && /^product/.test(tplMeta.getAttribute('content') || ''));
  function pdpTrust() {
    if (!isProduct) return;
    document.querySelectorAll('.estimated-shipping').forEach(function (es) {
      if (es.__bfz || !/dispatch|get it between/i.test(es.textContent || '')) return;
      es.__bfz = 1;
      var sec = es.closest('.shopify-section') || document;
      if (sec.querySelector('.bf26z-trust--pdp')) { es.remove(); return; }
      var t = document.getElementById('bf26z-tpl-pdp');
      if (!t) return;
      var d = document.createElement('div'); d.setAttribute('data-bf26z-slot', 'pdp'); d.innerHTML = t.innerHTML; es.replaceWith(d);
    });
    document.querySelectorAll('.bf26z-trust--pdp').forEach(function (u) {
      if (u.__bfz) return; u.__bfz = 1;
      var sec = u.closest('.shopify-section') || document;
      var rf = Array.prototype.some.call(sec.querySelectorAll('.estimated-shipping'), function (e) { return /risk-free/i.test(e.textContent || ''); });
      if (rf) { var li = u.querySelector('.bf26z-trust__item--extra'); if (li) li.remove(); } /* r55: the guarantee by name (the shipping item made it the 4th) */
    });
  }

  /* ---------- 3. small fixes that used to have their own observers ---------- */
  function labelSound() {
    var bs = document.querySelectorAll('.internal-video__sound-btn:not([aria-label])');
    for (var i = 0; i < bs.length; i++) bs[i].setAttribute('aria-label', 'Turn video sound on or off');
  }
  /* supplier key image with dimension text -> clean replacement file (draft theme only). To cover another product add a row to KEYMAP. */
  var KEYMAP = [['586f99964f44aa116d3615aa7b58.webp', 'bf33-washbag-key-sq.jpg']];
  var KATTR = ['src', 'srcset', 'data-src', 'data-srcset', 'data-fb', 'data-img', 'data-image', 'data-original', 'data-bb-img'];
  function kfix(s) {
    if (!s || typeof s !== 'string') return s;
    for (var k = 0; k < KEYMAP.length; k++) { if (s.indexOf(KEYMAP[k][0]) > -1) s = s.split(KEYMAP[k][0]).join(KEYMAP[k][1]); }
    return s;
  }
  function keyImages() {
    var els = document.querySelectorAll('img,source,[data-fb],[data-img],[data-image]');
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      for (var a = 0; a < KATTR.length; a++) {
        var v = e.getAttribute(KATTR[a]);
        if (v) { var n = kfix(v); if (n !== v) e.setAttribute(KATTR[a], n); }
      }
    }
    var js = document.querySelectorAll('script[type="application/json"]');
    for (var j = 0; j < js.length; j++) {
      if (js[j].__bfk) continue;
      js[j].__bfk = 1;
      var t = js[j].textContent;
      if (t) { var u = kfix(t); if (u !== t) js[j].textContent = u; }
    }
  }

  function all() { scanVideos(); scanReviews(); slots(); fixLinks(); labelSound(); } /* 21 Oct 2026: pdpTrust() off (no template has the estimated-shipping block); keyImages() off (the old wash-bag image is in no product, variant or template; it scanned every image attribute on every change) */
  BF.watch(all);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);

  /* ---------- 4. shared ladder UI (was bf26g-ladder-ui.js) ---------- */
(function () {
  if (window.BF26UI) return;
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  var SVG = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"';
  var ICONS = {
    ship: '<svg ' + SVG + '><path d="M2 6h11v9H2z"/><path d="M13 9h4l3 3v3h-7z"/><circle cx="6.5" cy="17.5" r="1.8" fill="currentColor" stroke="none"/><circle cx="16.5" cy="17.5" r="1.8" fill="currentColor" stroke="none"/></svg>',
    bag: '<svg ' + SVG + '><path d="M5 8h14l-1 12H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    gift: '<svg ' + SVG + '><path d="M3 9h18v4H3z"/><path d="M5 13v7h14v-7"/><path d="M12 9v11"/><path d="M12 9S9.5 3.5 7 5.5 9 9 12 9zm0 0s2.5-5.5 5-3.5S15 9 12 9z"/></svg>'
  };
  var CONFETTI = ['#5E7249', '#ADC299', '#C3D1B2', '#DCE3D0', '#4A573B', '#C3D1B2'];

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function perkIcon(t) { return /ship/i.test(t) && !/gift|mystery/i.test(t) ? ICONS.ship : ICONS.gift; } // wash bag and mystery gift both get the present icon
  function lab(t) { if (/^\s*\+/.test(t)) return String(t).trim(); return /ship/i.test(t) ? 'Free Shipping' : String(t || '').replace(/^\s*\d+\s*/, '').replace(/^free\s+/i, '').toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }
  function phrase(t) { t = String(t || '').replace(/^\s*\d+\s*/, '').toLowerCase(); return /ship/.test(t) || t.charAt(0) === '+' ? t : 'a ' + t; } // 'free shipping' / '+free wash bag' (r54: a perk written with + is a label, no article)
  // Round 17: savings figures (percentages, free perks) are wrapped so CSS can show them in green
  function hl(t) {
    return esc(t).replace(/(\d+(?:\.\d+)?%|\b\d+ free wash bags?\b|(?:\+|\b)free (?:wash bags?|shipping|mystery gifts?)\b)/gi, '<b class="bfp-g">$1</b>');
  }
  function fmt(t, v) {
    return String(t).replace(/\{(\w+)\}/g, function (a, k) { return v[k] !== undefined ? v[k] : a; });
  }

  var last = {};   // uid -> { pieces }

  function structKey(info, variant, quiet) {
    return variant + (quiet ? '|q|' : '|') + info.thresholds.join(',') + '|' + info.pcts.join(',') + '|' + JSON.stringify(info.allPerks || {});
  }


  function build(info, variant, quiet) {
    var E = window.bf26gLadder, th = info.thresholds, N = th.length;
    var trackW = ((N - 0.5) / N * 100).toFixed(3);
    var h = '<div class="bfp bfp--' + variant + '" style="--bfp-n:' + N + '">' +
      '<p class="bfp__nudge' + (quiet ? ' bfp-sr' : '') + '" aria-live="polite"><span class="bfp__count" data-bfp-count></span><span class="bfp__msg" data-bfp-msg></span></p>' +
      '<div class="bfp__rail"><span class="bfp__rowh">Items</span><div class="bfp__track" style="width:calc((100% - var(--bfp-rh,0px)) * ' + (trackW / 100).toFixed(5) + ')"><i class="bfp__fill" data-bfp-fill></i></div>' +
      '<ol class="bfp__nodes" aria-label="Savings milestones">';
    th.forEach(function (t, i) {
      var perk = (info.allPerks && info.allPerks[t]) || '', pct = info.pcts[i], up = pct > (info.pcts[i - 1] || 0), last = i === N - 1;
      h += '<li class="bfp__node" data-min="' + t + '">' +
        '<span class="bfp__lab">' + esc(perk ? lab(perk) : '') + '</span>' +
        '<span class="bfp__dot' + (up ? '' : ' is-icon') + '">' + (up ? '<strong>' + esc(E.pctLabel(pct)) + '</strong><small>off</small>' : perk ? perkIcon(perk) : '') + '</span>' +
        '<span class="bfp__lbl">' + t + (last ? '+' : '') + '</span>' +
        '<span class="bfp-sr">' + t + (last ? ' or more' : '') + ' items' + (up ? ', ' + esc(E.pctLabel(pct)) + ' off' : '') + (perk ? ', ' + esc(perk) : '') + '</span>' +
        '</li>';
    });
    h += '</ol></div>';
    if (variant !== 'xl') h += '<p class="bfp__save" data-bfp-save hidden></p>';
    return h + '</div>';
  }

  // position of the fill along the track (0..1). Nodes sit at the centre of equal columns, 0 items at the left edge.
  function fillFrac(n, th) {
    var N = th.length;
    function pos(i) { return (i + 0.5) / N; }
    var f;
    if (n <= 0) f = 0;
    else if (n <= th[0]) f = pos(0) * n / th[0];
    else {
      f = pos(N - 1);
      for (var i = 0; i < N - 1; i++) {
        if (n < th[i + 1]) { f = pos(i) + (pos(i + 1) - pos(i)) * (n - th[i]) / (th[i + 1] - th[i]); break; }
      }
    }
    return f / pos(N - 1);
  }

  // r53: the ONE writer of the ladder line (bf26y-fix.js and the drawer footer script no longer rewrite it).
  // "5 items · 1 more for 25% off" / "8 items · 30% off unlocked"; inside the cart drawer without the count. The drawer and cart page now use the rewards module (4b).
  function message(info, opts, flash, root) {
    if (flash) return flash;
    var T = opts.msgs || {}, r = info.remaining, n = (info.count != null ? info.count : info.pieces) || 0;
    var pre = (root && root.closest && root.closest('cart-drawer')) || n < 1 ? '' : n + (n === 1 ? ' item' : ' items') + ' · ';
    if (info.maxed) {
      var t = fmt(T.max || 'Top savings unlocked: {pct} off', { pct: info.pctText }), m = /^Top savings unlocked: (.+?)(?: every item)?$/.exec(t);
      return m ? pre + m[1] + ' unlocked' : t;
    }
    var up = info.nextPct > (info.pct || 0);
    return pre + r + ' more for ' + (up ? info.nextPctText + ' off' : phrase(info.nextPerk));
  }

  function burst(li) {
    if (RM.matches || !li || !li.animate) return;
    var dot = li.querySelector('.bfp__dot');
    if (!dot || !dot.offsetParent) return;
    var wrap = document.createElement('span');
    wrap.className = 'bfp__burst';
    dot.appendChild(wrap);
    for (var i = 0; i < 16; i++) {
      var p = document.createElement('i');
      p.className = 'bfp__p';
      var size = 5 + Math.random() * 5;
      p.style.cssText = 'width:' + size + 'px;height:' + (Math.random() > .5 ? size : size * 1.8) + 'px;background:' + CONFETTI[i % CONFETTI.length] + ';';
      wrap.appendChild(p);
      var ang = (i / 16) * Math.PI * 2 + Math.random() * 0.5;
      var dist = 46 + Math.random() * 46;
      var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist - 14;
      p.animate([
        { transform: 'translate(-50%,-50%) rotate(0deg) scale(1)', opacity: 1 },
        { transform: 'translate(calc(-50% + ' + dx.toFixed(1) + 'px), calc(-50% + ' + (dy + 26).toFixed(1) + 'px)) rotate(' + Math.round(Math.random() * 540 - 270) + 'deg) scale(.5)', opacity: 0 }
      ], { duration: 900 + Math.random() * 500, easing: 'cubic-bezier(.12,.7,.3,1)', fill: 'forwards' });
    }
    setTimeout(function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 1600);
  }

  function pop(li) {
    li.classList.remove('is-pop'); void li.offsetWidth; li.classList.add('is-pop');
    setTimeout(function () { li.classList.remove('is-pop'); }, 1100);
  }

  // Full-screen confetti, stars and fireworks (~4.6s) when the top rung is reached, no text card (UX round 20): the small nudge line above the ladder carries the message.
  // Opt-in per mount point with data-celebrate. pointer-events:none, reduced motion = nothing.
  var PARTY = ['#5E7249', '#ADC299', '#C3D1B2', '#4A573B', '#C3D1B2', '#C3D1B2', '#FFFFFF'];
  function party(root) {
    var box = document.createElement('div'), r = Math.random, pal = PARTY.slice();
    var f = root.querySelector('.bfp'), cs = f && window.getComputedStyle ? window.getComputedStyle(f) : null;
    if (cs) { pal[0] = cs.getPropertyValue('--bfp-acc').trim() || pal[0]; pal[3] = cs.getPropertyValue('--bfp-green').trim() || pal[3]; }
    box.className = 'bfp-party'; box.setAttribute('aria-hidden', 'true');
    box.style.cssText = 'position:fixed;inset:0;z-index:2147483000;pointer-events:none';
    if (box.animate && !RM.matches) box.animate([{ opacity: 0 }, { opacity: 1, offset: 0.08 }, { opacity: 1, offset: 0.85 }, { opacity: 0 }], 4600);
    document.body.appendChild(box);
    function end() { if (box.parentNode) box.parentNode.removeChild(box); }
    var cv = document.createElement('canvas'), g = RM.matches || !window.requestAnimationFrame ? null : cv.getContext('2d');
    if (!g) { end(); return; }
    var W = window.innerWidth, H = window.innerHeight, dpr = Math.min(window.devicePixelRatio || 1, 1.5), ps = [], fw = [350, 1100, 1900, 2700], t0 = performance.now();
    cv.width = W * dpr; cv.height = H * dpr; cv.setAttribute('aria-hidden', 'true'); cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none'; box.insertBefore(cv, box.firstChild); g.scale(dpr, dpr);
    for (var i = 0; i < 110; i++) ps.push({ k: i % 4 ? 'c' : 's', x: r() * W, y: -20 - r() * H * 0.6, vx: r() - 0.5, vy: 2 + r() * 3, a: r() * 6, va: r() * 0.2 - 0.1, z: 5 + r() * 7, col: pal[i % pal.length], life: 1 });
    function boom(x, y) {
      var col = pal[(r() * pal.length) | 0];
      for (var j = 0; j < 38; j++) { var an = j / 38 * 6.283 + r() * 0.2, sp = 2 + r() * 4; ps.push({ k: 'f', x: x, y: y, vx: Math.cos(an) * sp, vy: Math.sin(an) * sp, z: 2 + r() * 1.6, col: col, life: 1 }); }
    }
    function star(x, y, rad, a) {
      g.beginPath();
      for (var q = 0; q < 10; q++) { var rr = q % 2 ? rad * 0.45 : rad, an = a + q * Math.PI / 5; g.lineTo(x + Math.cos(an) * rr, y + Math.sin(an) * rr); }
      g.closePath(); g.fill();
    }
    (function tick(now) {
      var t = now - t0, fade = t > 4000 ? Math.max(0, 1 - (t - 4000) / 600) : 1;
      g.clearRect(0, 0, W, H);
      while (fw.length && t > fw[0]) { fw.shift(); boom(W * (0.2 + r() * 0.6), H * (0.18 + r() * 0.3)); }
      ps.forEach(function (p) {
        p.x += p.vx; p.y += p.vy;
        if (p.k === 'f') { p.vy += 0.06; p.vx *= 0.985; p.life -= 0.014; } else { p.a += p.va; p.vx += (r() - 0.5) * 0.06; }
        if (p.life <= 0 || p.y > H + 30) return;
        g.globalAlpha = p.life * fade; g.fillStyle = p.col;
        if (p.k === 's') star(p.x, p.y, p.z * 1.4, p.a);
        else if (p.k === 'c') { g.save(); g.translate(p.x, p.y); g.rotate(p.a); g.fillRect(-p.z / 2, -p.z * 0.3, p.z, p.z * 0.6); g.restore(); }
        else { g.beginPath(); g.arc(p.x, p.y, p.z, 0, 6.283); g.fill(); }
      });
      if (t < 4600) requestAnimationFrame(tick); else end();
    })(t0);
  }

  function render(root, info, opts) {
    opts = opts || {};
    var E = window.bf26gLadder;
    if (!root || !info || !E || !info.thresholds) return;
    var variant = root.getAttribute('data-variant') || 'compact';
    var quiet = root.hasAttribute('data-nonudge'), key = structKey(info, variant, quiet);
    if (root.__bfpKey !== key) { root.innerHTML = build(info, variant, quiet); root.__bfpKey = key; }
    root.__bfpLast = { info: info, opts: opts };

    var uid = root.getAttribute('data-uid') || 'x';
    var n = (info.count != null ? info.count : info.pieces) || 0, start = info.thresholds[0];
    var prev = last[uid];
    var unlocked = [];
    if (prev && n < prev.pieces) root.__flash = null; // pieces went down: drop any 'Unlocked' line

    var nodes = root.querySelectorAll('.bfp__node');
    for (var i = 0; i < nodes.length; i++) {
      var li = nodes[i], min = +li.getAttribute('data-min');
      var on = n >= min;
      li.classList.toggle('is-on', on);
      li.classList.toggle('is-next', info.next === min);
      if (on && prev && prev.pieces < min && opts.celebrate !== false) unlocked.push(li);
    }

    var fill = root.querySelector('[data-bfp-fill]');
    if (fill) fill.style.width = (fillFrac(n, info.thresholds) * 100).toFixed(2) + '%';

    var count = root.querySelector('[data-bfp-count]');
    if (count) count.textContent = n < start ? (n + ' of ' + start) : (n + (n === 1 ? ' item' : ' items'));
    root.classList.toggle('is-started', n >= start);

    if (unlocked.length && root.hasAttribute('data-celebrate') && +unlocked[unlocked.length - 1].getAttribute('data-min') === info.thresholds[info.thresholds.length - 1]) party(root);
    if (unlocked.length) {
      var top = unlocked[unlocked.length - 1];
      var pi = info.thresholds.indexOf(+top.getAttribute('data-min'));
      var pctTxt = info.pcts[pi] ? E.pctLabel(info.pcts[pi]) + ' off' : '';
      var perk = (info.allPerks && info.allPerks[+top.getAttribute('data-min')]) || '';
      root.__flash = { until: Date.now() + 3200, text: 'Unlocked: ' + (pctTxt || perk.toLowerCase()) + (pctTxt && perk ? ' + ' + perk.toLowerCase() : '') };
      unlocked.forEach(function (u) { pop(u); burst(u); });
      setTimeout(function () {
        if (root.isConnected && root.__bfpLast) render(root, root.__bfpLast.info, { celebrate: false, msgs: root.__bfpLast.opts.msgs, blocked: root.__bfpLast.opts.blocked });
      }, 3300);
    }
    var flash = root.__flash && Date.now() < root.__flash.until ? root.__flash.text : '';
    var msg = root.querySelector('[data-bfp-msg]');
    if (msg) {
      msg.innerHTML = hl(message(info, opts, flash, root));
      root.classList.toggle('is-flash', !!flash);
    }

    var save = root.querySelector('[data-bfp-save]');
    if (save) {
      if (n >= start && info.savingsCents > 0) { save.hidden = false; save.innerHTML = 'You save <b class="bfp-g">' + esc(info.savingsText) + '</b>'; }
      else save.hidden = true;
    }
    last[uid] = { pieces: n };
  }

  // ---- automatic roots (cart drawer, cart page): follow the cart ----
  var lastAuto = null;
  function autoRender(info) {
    var roots = document.querySelectorAll('[data-bf26-progress]:not([data-manual])');
    for (var i = 0; i < roots.length; i++) render(roots[i], info, { blocked: !!info.blocked });
  }
  // a progress root that appears later (cart drawer re-render) or lost its markup is painted from the last cart info
  function paintNew() {
    if (!lastAuto) return;
    var roots = document.querySelectorAll('[data-bf26-progress]:not([data-manual])');
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      if (!r.__bfpKey || !r.firstElementChild) render(r, lastAuto, { blocked: !!lastAuto.blocked });
    }
  }
  BF.engine(function (E) {
    E.onUpdate(function (info) { lastAuto = info; autoRender(info); });
    // live cart: besides the engine's own fetch/XHR hooks, re-read /cart.js after theme cart events and after clicks/submits on cart controls (PDP add to cart, drawer qty/remove, cart page)
    var tm = 0, tm2 = 0;
    function soon() { clearTimeout(tm); tm = setTimeout(function () { E.refresh(); }, 150); }
    function later() { soon(); clearTimeout(tm2); tm2 = setTimeout(function () { E.refresh(); }, 1500); }
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:update', 'cart:added', 'cart-drawer:updated', 'ajaxProduct:added', 'product:added', 'bf26:cart'].forEach(function (n) { document.addEventListener(n, soon); });
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('cart-drawer button, cart-drawer a, cart-items button, cart-items a, [name="add"], [data-add-to-cart], .quantity button, a[href*="/cart/change"]') : null;
      if (t) later();
    }, true);
    document.addEventListener('submit', function (e) { var f = e.target; if (f && f.action && /\/cart\/(add|update|change)/.test(f.action)) later(); }, true);
    document.addEventListener('change', function (e) { var t = e.target; if (t && t.closest && t.closest('cart-drawer, cart-items, form[action*="/cart"]') && t.matches('input') && t.name !== 'id') later(); }, true); // name=id is the PDP variant id: a colour change, not a cart change
  });
  BF.watch(paintNew);

  window.BF26UI = { render: render, reducedMotion: function () { return RM.matches; } };
})();

  /* ---------- 4b. The ONE ladder progress bar (Phase 1 wash bag rewards, 20 Oct 2026; was the r53 next-reward module) ----------
     The first paint is server HTML (snippets/bf26g-rewards.liquid). This only repaints a bar when the paid piece count changed without a section re-render,
     with the engine's own markup (bf26gLadder.rewards / rewardsInner), so the copy never flips. A cart read older than the HTML on screen is never painted.
     The fill slides from the old width once, and the "Unlocked" line eases in when a reward unlocks (CSS .rkl--unlock, none under prefers-reduced-motion). */
(function () {
  if (window.BF26Rewards) return;
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var shown = {}, latest = null, SEL = '[data-rk-rewards]';
  function fillOf(root) { var f = root.querySelector('.rkl__fill'), m = f && /--rk-fill:\s*(\d+)/.exec(f.getAttribute('style') || ''); return m ? +m[1] : 0; }
  function now(root) { return { n: +root.getAttribute('data-rk-count') || 0, unlocked: +root.getAttribute('data-rk-unlocked') || 0, fill: fillOf(root) }; }
  function slide(root, from, to) {
    var f = root.querySelector('.rkl__fill');
    if (!f || RM.matches || from === to) return;
    f.style.setProperty('--rk-fill', from); void f.offsetWidth;
    requestAnimationFrame(function () { f.style.setProperty('--rk-fill', to); });
  }
  function moved(root, prev, cur) {
    if (!prev || RM.matches) return;
    if (cur.unlocked > prev.unlocked) {
      root.classList.remove('rkl--unlock'); void root.offsetWidth; root.classList.add('rkl--unlock');
      clearTimeout(root.__rkT); root.__rkT = setTimeout(function () { root.classList.remove('rkl--unlock'); }, 900);
    }
    if (root.__rkFresh) slide(root, prev.fill, cur.fill); // a swapped-in root (section re-render): slide from the old width once
  }
  function paint(root, info) {
    var E = window.bf26gLadder;
    if (!E || !E.rewards || !info) return;
    if (info.at && root.__rkBorn && info.at < root.__rkBorn) return;
    var n = info.count || 0, cur = now(root);
    if (cur.n === n && root.querySelector('.rkl__rail')) return;
    if (!root.__rkWarned && root.getAttribute('data-rk-server-sig') === info.sig && cur.n !== n) {
      root.__rkWarned = 1;
      try { console.warn('rk rewards: server/client count ' + cur.n + '/' + n + ' for the same cart. Check the product tag `ladder` against the BF26 Ladder data blocks.'); } catch (e) {}
    }
    var s = E.rewards(n);
    root.innerHTML = E.rewardsInner(s, root.getAttribute('data-rk-variant') === 'compact');
    root.setAttribute('data-rk-count', n);
    root.setAttribute('data-rk-unlocked', s.unlocked);
    root.classList.toggle('rkl--max', s.next === null);
    slide(root, cur.fill, s.fill);
    root.__rkFresh = false;
    var c = now(root), ctx = (root.getAttribute('data-rk-ctx') || 'x') + (root.getAttribute('data-rk-variant') || '');
    moved(root, shown[ctx], c);
    shown[ctx] = c;
  }
  function scan() {
    var roots = document.querySelectorAll(SEL);
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      if (r.__rkBorn) continue;
      r.__rkBorn = Date.now(); r.__rkFresh = true;
      var ctx = (r.getAttribute('data-rk-ctx') || 'x') + (r.getAttribute('data-rk-variant') || ''), c = now(r);
      moved(r, shown[ctx], c);
      shown[ctx] = c;
      r.__rkFresh = false;
      if (latest) paint(r, latest);
    }
  }
  BF.watch(scan);
  scan();
  BF.engine(function (E) {
    E.onUpdate(function (info) {
      latest = info;
      var roots = document.querySelectorAll(SEL);
      for (var i = 0; i < roots.length; i++) paint(roots[i], info);
    });
  });
  window.BF26Rewards = { paint: paint, scan: scan };
})();

  /* ---------- 5. Build-a-Bundle checkout gate (was bf26-bundle-gate.js) ---------- */
(function () {
  if (window.BF26Gate) return;
  var BTN = '#CartDrawer-Checkout, #checkout, button[name="checkout"], input[name="checkout"]';
  var info = null;

  function blocked() { return !!(info && info.blocked); }
  function label() { return 'Add ' + info.needMore + ' more to complete your bundle'; }

  function applyButton(b) {
    if (blocked()) {
      var l = label();
      if (b.__bfOrig === undefined) b.__bfOrig = b.innerHTML;
      b.disabled = true;
      b.setAttribute('aria-disabled', 'true');
      b.classList.add('bf26-gate-btn');
      var span = b.querySelector('.button__label');
      var target = span || b;
      if (b.tagName === 'INPUT') { if (b.value !== l) b.value = l; }
      else if (target.textContent.trim() !== l) { target.textContent = l; }
    } else if (b.__bfOrig !== undefined) {
      b.innerHTML = b.__bfOrig; delete b.__bfOrig;
      b.classList.remove('bf26-gate-btn');
      b.removeAttribute('aria-disabled');
      var c = window.bf26gLadder && window.bf26gLadder.getCart(); if (c && c.item_count > 0) b.disabled = false;
    }
  }
  function applyMessage(b) {
    var host = b.closest('.cart__ctas') || b.parentElement;
    if (!host) return;
    var m = host.parentElement && host.parentElement.querySelector(':scope > [data-bf26-gate-msg]');
    if (blocked()) {
      var text = 'Your bundle needs ' + info.start + ' items. Add ' + info.needMore + ' more to check out and unlock your savings.';
      if (!m) {
        m = document.createElement('p');
        m.className = 'bf26-gate-msg'; m.setAttribute('data-bf26-gate-msg', ''); m.setAttribute('role', 'status');
        host.parentElement.insertBefore(m, host);
      }
      if (m.textContent !== text) m.textContent = text;
    } else if (m) m.remove();
  }
  function apply() {
    if (!info) return;
    document.body.classList.toggle('bf26-gated', blocked());
    var btns = document.querySelectorAll(BTN);
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.tagName === 'BUTTON' && b.type === 'button') continue;
      applyButton(b); applyMessage(b);
    }
    if (!blocked()) {
      var ms = document.querySelectorAll('[data-bf26-gate-msg]');
      for (var j = 0; j < ms.length; j++) ms[j].remove();
    }
  }

  function stop(e) { e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); }

  document.addEventListener('click', function (e) {
    if (!blocked()) return;
    var t = e.target && e.target.closest ? e.target.closest(BTN + ', a[href*="/checkout"], shopify-accelerated-checkout-cart, shopify-accelerated-checkout, .additional-checkout-buttons, .shopify-payment-button') : null;
    if (t) stop(e);
  }, true);
  document.addEventListener('submit', function (e) {
    if (!blocked()) return;
    var f = e.target, sub = e.submitter;
    var act = (f && f.getAttribute && f.getAttribute('action')) || '';
    if ((sub && sub.name === 'checkout') || /\/checkout/.test(act) || (f.querySelector && f.querySelector('[name="checkout"]') && /\/cart/.test(act))) stop(e);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (!blocked() || e.key !== 'Enter') return;
    var f = e.target && e.target.form;
    if (f && (f.querySelector('[name="checkout"]'))) { var t = e.target; if (t.tagName !== 'TEXTAREA' && t.tagName !== 'BUTTON') stop(e); }
  }, true);

  BF.engine(function (E) { E.onUpdate(function (i) { info = i; apply(); }); });
  BF.watch(apply);
  window.BF26Gate = { blocked: blocked, info: function () { return info; } };
})();

/* ---- 21 Oct 2026: shipping rate in the shopper's currency (snippets/rk-ship-text.liquid prints A$ with data-rk-ship-aud; product ticks, cart drawer, cart page). Here, not inline, so redrawn drawers convert too. */
(function () {
  function fx(el) {
    var c = window.Shopify && Shopify.currency;
    if (!c || !c.rate || c.active === 'AUD') return;
    var v = Math.round(parseFloat(el.getAttribute('data-rk-ship-aud')) * parseFloat(c.rate));
    if (!(v > 0)) return;
    var t;
    try { t = window.bf26Money ? window.bf26Money(v) : new Intl.NumberFormat('en-' + ((window.Shopify && Shopify.country) || 'US'), { style: 'currency', currency: c.active }).format(v / 100); } catch (e) { return; }
    el.textContent = t; el.setAttribute('data-rk-done', '');
  }
  /* 25 Oct 2026: the cart Total row for the International zone = cart total (shopper's currency) + A$3.50 converted */
  function tot(el) {
    var c = window.Shopify && Shopify.currency;
    var base = parseInt(el.getAttribute('data-rk-total-base'), 10), add = parseFloat(el.getAttribute('data-rk-ship-aud-add'));
    if (!(base >= 0) || !(add > 0)) return;
    var v = base + Math.round(add * (c && c.rate && c.active !== 'AUD' ? parseFloat(c.rate) : 1));
    var t;
    try { t = window.bf26Money ? window.bf26Money(v) : new Intl.NumberFormat('en-' + ((window.Shopify && Shopify.country) || 'US'), { style: 'currency', currency: (c && c.active) || 'AUD' }).format(v / 100); } catch (e) { return; }
    el.textContent = t; el.setAttribute('data-rk-done', '');
  }
  function all() { document.querySelectorAll('[data-rk-ship-aud]:not([data-rk-done])').forEach(fx); document.querySelectorAll('[data-rk-total-base]:not([data-rk-done])').forEach(tot); }
  all(); BF.watch(all);
})();
})();
